<div *ngIf="isLoading">
	<mat-icon>
		<mat-spinner diameter="20"> </mat-spinner>
	</mat-icon>
</div>
<div *ngIf="!isLoading">
	<div class="margin-top-sm table-responsive">
		<mat-table [dataSource]="tableDataSources[0]" class="mat-elevation-z1" matSort>

			<ng-container matColumnDef="WARNINGS">
				<mat-header-cell *matHeaderCellDef> </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<span *ngFor="let warning of element.WARNINGS; let i = index">
						<mat-icon [class]="warning.CLASS + ' margin-horizontal-xs'" [matTooltip]="warning.TOOLTIP"
							matTooltipClass="bigger-tooltip">{{warning.ICON}}</mat-icon>
					</span>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="NAME">
				<mat-header-cell *matHeaderCellDef> Child </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.NAME}} </mat-cell>
			</ng-container>

			<ng-container matColumnDef="MSD_NUMBER">
				<mat-header-cell *matHeaderCellDef> MSD Number </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.MSD_NUMBER}} </mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL.NAME">
				<mat-header-cell *matHeaderCellDef> Current School Anchor </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.SCHOOL.NAME}} -
					{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE}} </mat-cell>
			</ng-container>

			<ng-container matColumnDef="SERVICE_DELIVERIES[0].NAME">
				<mat-header-cell *matHeaderCellDef> Affected Services </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<ul class="row">
						<li *ngFor="let sd of element.SERVICE_DELIVERIES">
							{{sd.SERVICE_NAME}} - {{sd.GRADE}}
						</li>
					</ul>
					<span *ngIf="element.SERVICE_DELIVERIES.length === 0">---</span>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="ACTION">
				<mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<span [class]="element.ACTION.CLASS">{{element.ACTION.STRING}}</span>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOLS[0].NAME">
				<mat-header-cell *matHeaderCellDef> New School Anchor </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<span *ngIf="element.NEW_ANCHOR">{{element.SCHOOLS[0].NAME}} - {{element.SCHOOLS[0].GRADE}}</span>
					<span *ngIf="!element.NEW_ANCHOR">---</span>
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
		</mat-table>
	</div>
</div>